import { useState, useContext, useEffect } from "react";
import { useMutation, useLazyQuery } from "@apollo/client";
import { loadConnectAndInitialize } from '@stripe/connect-js';
import { getCookie } from "../utils/cookie";
import { PublisherAndUserContext } from '../contexts/PublisherAndUserContext';
import { refresh_url, return_url } from "../config";
import {
  CREATE_CONNECTED_ACCOUNT,
  CREATE_CONNECTED_ACCOUNT_LINK
} from "../graphql/mutations";
import {
  USER_PUBLISHER_ROLE
} from "../graphql/queries";

export const useAccountSession = ({ user, accountId, component, publisherId }) => {

  const [loading, setLoading] = useState(false);
  const { publisher } = useContext(PublisherAndUserContext);
  const postUrl = process.env.REACT_APP_ADMIN_APP_GRAPHQL_ENDPOINT;

  const [stripeConnectInstance] = useState(() => {
    const fetchClientSecret = async () => {
      if (accountId !== null) {
        const response = await fetch(postUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "x-access-token": getCookie("dyn_session"),
          },
          body: JSON.stringify({
            query: `
                mutation EdshopifyCreateSConnectedAccountSession($where: EdshopifyCreateSConnectedAccountWhereInput!, $data: EdshopifyCreateSConnectedAccountSessionInput!) {
                    edshopifyCreateSConnectedAccountSession(where: $where, data: $data) {
                        token
                        expires_at
                    }
                }
              `,
            variables: {
              data: {
                component: component
              },
              where: {
                id: publisher.id
              }
            },
          }),
        }).then((res) => res.json());
        const { token } = await response.data.edshopifyCreateSConnectedAccountSession;
        return token;
      }
    }
    return loadConnectAndInitialize({
      publishableKey: process.env.REACT_APP_STRIPE_PUBLISH_KEY,
      fetchClientSecret: fetchClientSecret,
    })
  });

  const [createConnectAccount] = useMutation(CREATE_CONNECTED_ACCOUNT, {
    onCompleted: (data) => {
      createConnectAccountLink({
        variables: {
          data: {
            refresh_url: refresh_url,
            return_url: return_url
          },
          where: {
            id: publisher?.id
          }
        }
      })
    },
    onError: () => {
      setLoading(false)
    },
  });

  const [createConnectAccountLink] = useMutation(CREATE_CONNECTED_ACCOUNT_LINK, {
    onCompleted: (data) => {
      setLoading(false)
      window.location.href = data.edshopifyCreateSConnectedAccountLink.url
    },
    onError: () => {
      setLoading(false)
    },
  });

  const [getUserPublisherAndRole] = useLazyQuery(USER_PUBLISHER_ROLE, {
    onCompleted: (data) => {
      setLoading(false)
  },
  });

  const createStripeConnectedAccount = () => {
    setLoading(true)
    if (publisherId) {
      createConnectAccount({
        variables: {
          data: {
            email: user.email,
            country: "US"
          },
          where: {
            id: publisherId
          }
        }
      })
    }
  }
  const createStripeConnectedAccountLink = () => {
    setLoading(true)
    if (publisherId) {
      createConnectAccountLink({
        variables: {
          data: {
            refresh_url: refresh_url,
            return_url: return_url
          },
          where: {
            id: publisher?.id
          }
        }
      })
    }
  }

  useEffect(() => {
    if(!publisher?.otherInfo?.isOnBoardingCompleted) {
      setLoading(true)
      getUserPublisherAndRole({
        variables: {
          where: {
            ...(user.email
              ? { email: user?.email }
              : { phone: user?.phone }),
          },
        },
      });
    }
  },[])

  return {
    stripeConnectInstance,
    createStripeConnectedAccount,
    createStripeConnectedAccountLink,
    loading,
  }

}